const md = `# Folders & Run Numbers

Two organisational primitives that work together.

## Folders

Folders are user-defined collections of runs.  Anyone can create a
folder; runs you add belong to that folder until you remove them.

### Creating a folder

Top-nav → **Folders** → **+ New folder**.  Give it a name, a
visibility (Private / Team / Public), and optionally a short
description.

### Adding runs

On any run-detail page, click the **Folder chip** below the run number
to open a multi-select dropdown of your folders.  Tick the ones you
want; the badge count on the folder card updates instantly.

### Sharing a folder

A folder's public share link surfaces every run inside it (filtered to
runs that aren't themselves private).  Great for "here are the four
demos I want you to review this week".

## Run Numbers

Every demo run gets a **global, monotonically-increasing 4-digit Run
Number** at creation time — \`0001\`, \`0002\`, \`0003\`, … — assigned
by an atomic Mongo counter so two simultaneous runs never collide.

### Why it matters

* **Easy to reference in conversation.** "Did you see run #0089?" is
  shorter than a UUID.
* **Searchable.** History page's run-number filter accepts the bare
  number or the zero-padded form.
* **Stamped into filenames.** The auto-pipeline names its MP4
  \`stitched_<timestamp>_<run-id-prefix>.mp4\` and the Playwright video
  carries the run UUID — both can be cross-referenced with the run
  number on the detail page.

### Looking up a run by number

The History page has a **Run #** search box.  Or hit
\`GET /api/demo-runs/by-number/{run_number}\` if you're scripting.
`;

export default md;
